import { render, staticRenderFns } from "./TripDocumentTable.vue?vue&type=template&id=42ba16d8"
import script from "./TripDocumentTable.vue?vue&type=script&lang=js"
export * from "./TripDocumentTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports